/* ============================================================
   Quelton — colección y búsqueda (sobre q-theme.js)
   Portado de ~/Quelton-paginaweb/assets/js/coleccion.js, pero con los filtros nativos de Shopify:
   cada cambio pide la misma sección con ?section_id= y sustituye solo las zonas [data-q-render],
   sin recargar. El estado va en la URL (se puede compartir y volver atrás).
   Desplegables · panel de filtros (móvil) · "Solo mi talla" · ordenar · 2/4 por fila · "Ver más".
   ============================================================ */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const Q = () => window.Q || {};

  function init(root) {
    if (!root || root.dataset.qReady) return;
    root.dataset.qReady = '1';
    const sectionId = root.dataset.sectionId;
    const panel = $('[data-filters]', root);
    const overlay = $('[data-overlay]');
    let controller = null;

    // ---------- pedir la sección y sustituir zonas ----------
    const sectionUrl = (url) => {
      const u = new URL(url, location.origin);
      u.searchParams.set('section_id', sectionId);
      return u;
    };
    const cleanUrl = (url) => {
      const u = new URL(url, location.origin);
      u.searchParams.delete('section_id');
      u.searchParams.delete('page');
      return u.pathname + (u.search ? u.search : '');
    };

    async function load(url, { push = true } = {}) {
      if (controller) controller.abort();
      controller = new AbortController();
      const openDrop = $('[data-drop].is-open', root)?.dataset.drop;
      root.classList.add('is-loading');
      try {
        const res = await fetch(sectionUrl(cleanUrl(url)), { signal: controller.signal });
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        $$('[data-q-render]', root).forEach((el) => {
          const fresh = $(`[data-q-render="${el.dataset.qRender}"]`, doc);
          if (fresh) el.innerHTML = fresh.innerHTML;
        });
        if (push) history.pushState({ qPlp: true }, '', cleanUrl(url));
        afterRender();
        if (openDrop) {
          const d = $(`[data-drop="${openDrop}"]`, root);
          if (d) { d.classList.add('is-open'); $('[data-drop-btn]', d)?.setAttribute('aria-expanded', 'true'); }
        }
      } catch (e) {
        if (e.name !== 'AbortError') location.href = cleanUrl(url);
      } finally {
        root.classList.remove('is-loading');
      }
    }

    function afterRender(scope = root) {
      Q().registerProducts?.(scope);
      Q().initReveal?.(scope);
      applyCols();
      renderMySize();
    }

    // ---------- formulario → URL ----------
    function urlFromForm(form) {
      const params = new URLSearchParams();
      new FormData(form).forEach((v, k) => {
        if (v === '' || k === 'sort_by') return;
        if (form.querySelector(`[name="${CSS.escape(k)}"][data-q-price]`)) v = String(v).replace(/\s/g, '').replace(',', '.');
        params.append(k, v);
      });
      const sort = $('[data-q-sort]', root);
      if (sort && sort.value) params.set('sort_by', sort.value);
      const action = new URL(form.getAttribute('action') || location.pathname, location.origin);
      return `${action.pathname}?${params.toString()}`;
    }
    const activeForm = () => {
      const panelOpen = panel && panel.classList.contains('is-open');
      return panelOpen ? $('form[data-q-facets]', panel) : $('form.filter-drops[data-q-facets]', root) || $('form[data-q-facets]', root);
    };

    root.addEventListener('change', (e) => {
      const input = e.target;
      if (input.matches('[data-q-sort]')) {
        const form = activeForm();
        if (form) { load(urlFromForm(form)); return; }
        const u = new URL(location.href);
        u.searchParams.set('sort_by', input.value);
        load(u.href);
        return;
      }
      if (input.matches('[data-q-price]')) return; // se aplica con el botón o Intro
      if (input.form && input.form.matches('[data-q-facets]')) load(urlFromForm(input.form));
    });
    root.addEventListener('submit', (e) => {
      const form = e.target.closest('form[data-q-facets]');
      if (!form) return;
      e.preventDefault();
      load(urlFromForm(form));
    });

    // ---------- clics: enlaces de filtros, desplegables, "Ver más" ----------
    // (escuchamos en la sección para adelantarnos a la transición de página de q-theme.js)
    root.addEventListener('click', (e) => {
      const link = e.target.closest('a[data-q-url]');
      if (link && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
        e.preventDefault();
        load(link.href);
        return;
      }
      const more = e.target.closest('a[data-q-more]');
      if (more && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
        e.preventDefault();
        loadMore(more);
      }
    });

    async function loadMore(btn) {
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(sectionUrl(btn.href));
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const grid = $('[data-q-grid]', root);
        const added = $$(`[data-q-render="grid"] > :not(.plp-editorial):not(.plp-empty)`, doc);
        const frag = document.createDocumentFragment();
        added.forEach((el) => frag.appendChild(document.importNode(el, true)));
        const holder = document.createElement('div');
        holder.appendChild(frag);
        const firstNew = holder.firstElementChild;
        Q().registerProducts?.(holder);
        while (holder.firstChild) grid.appendChild(holder.firstChild);
        const freshMore = $('[data-q-render="more"]', doc);
        const more = $('[data-q-render="more"]', root);
        if (freshMore && more) more.innerHTML = freshMore.innerHTML;
        $('.plp-more__prev', more)?.remove();
        Q().initReveal?.(grid);
        // llevar el foco a la primera tarjeta nueva (accesibilidad)
        const a = firstNew && $('a[href]', firstNew);
        if (a) a.focus({ preventScroll: true });
      } catch (err) {
        location.href = btn.href;
      } finally {
        btn.removeAttribute('aria-busy');
      }
    }

    // desplegables de la barra
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-drop-btn]');
      $$('[data-drop].is-open', root).forEach((d) => {
        if (!btn || d !== btn.closest('[data-drop]')) {
          if (!d.contains(e.target)) { d.classList.remove('is-open'); $('[data-drop-btn]', d)?.setAttribute('aria-expanded', 'false'); }
        }
      });
      if (btn && root.contains(btn)) {
        const d = btn.closest('[data-drop]');
        d.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(d.classList.contains('is-open')));
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      $$('[data-drop].is-open', root).forEach((d) => d.classList.remove('is-open'));
      if (panel && panel.classList.contains('is-open')) openPanel(false);
    });

    // ---------- panel de filtros (móvil) ----------
    function openPanel(open) {
      if (!panel) return;
      panel.classList.toggle('is-open', open);
      panel.setAttribute('aria-hidden', String(!open));
      overlay?.classList.toggle('is-open', open);
      document.body.classList.toggle('is-locked', open);
      if (open) $('[data-filters-close]', panel)?.focus();
      else $('[data-filters-open]', root)?.focus();
    }
    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-filters-open]')) openPanel(true);
      else if (e.target.closest('[data-filters-close], [data-filters-apply]')) openPanel(false);
    });
    overlay?.addEventListener('click', () => { if (panel?.classList.contains('is-open')) openPanel(false); });

    // ---------- 2 / 4 por fila ----------
    const getCols = () => { try { return localStorage.getItem('quelton-cols') || '4'; } catch { return '4'; } };
    function applyCols() {
      const cols = getCols();
      const grid = $('[data-q-grid]', root);
      if (grid) grid.dataset.cols = cols;
      $$('[data-cols]', root).forEach((b) => b.tagName === 'BUTTON' && b.setAttribute('aria-pressed', String(b.dataset.cols === cols)));
    }
    root.addEventListener('click', (e) => {
      const b = e.target.closest('button[data-cols]');
      if (!b) return;
      try { localStorage.setItem('quelton-cols', b.dataset.cols); } catch {}
      applyCols();
    });

    // ---------- "Solo mi talla" (usa la talla guardada con "Adivina tu talla") ----------
    const mySizeBtn = $('[data-my-size]', root);
    const mySize = () => Q().Size?.get?.() || null;
    function sizeTargets(form, mine) {
      if (!form || !mine) return [];
      const top = String(mine.top || '').toUpperCase();
      const bottom = String(mine.bottom || '').toUpperCase();
      return $$('input[data-q-size-part]', form).filter((i) => {
        const v = i.dataset.qSizeValue;
        const part = i.dataset.qSizePart;
        if (part === 'top') return v === top;
        if (part === 'bottom') return v === bottom;
        return v === top || v === bottom;
      });
    }
    function renderMySize() {
      if (!mySizeBtn) return;
      mySizeBtn.hidden = false;
      const mine = mySize();
      const targets = sizeTargets(activeForm(), mine).filter((i) => !i.disabled || i.checked);
      const on = !!mine && targets.length > 0 && targets.every((i) => i.checked);
      mySizeBtn.setAttribute('aria-pressed', String(on));
      const label = $('[data-my-size-label]', mySizeBtn);
      if (!label.dataset.base) label.dataset.base = label.textContent;
      label.textContent = mine ? `${label.dataset.base} · ${mine.top === mine.bottom ? mine.top : `${mine.top}/${mine.bottom}`}` : label.dataset.base;
    }
    function toggleMySize(force) {
      const mine = mySize();
      if (!mine) { Q().openQuiz?.(); return; }
      const form = activeForm();
      const targets = sizeTargets(form, mine);
      if (!targets.length) { Q().toast?.(mySizeBtn?.dataset.empty || ''); return; }
      const on = force !== undefined ? force : !targets.every((i) => i.checked);
      targets.forEach((i) => { if (!i.disabled || i.checked) i.checked = on; });
      load(urlFromForm(form));
    }
    mySizeBtn?.addEventListener('click', () => toggleMySize());
    document.addEventListener('quelton:size', () => { if (mySizeBtn) toggleMySize(true); });

    // ---------- barra fija bajo la cabecera ----------
    const toolbar = $('[data-q-toolbar]', root);
    const header = $('.site-header') || $('.shopify-section-group-header-group');
    let ticking = false;
    function placeToolbar() {
      ticking = false;
      if (!toolbar) return;
      let top = 0;
      if (header) {
        const pos = getComputedStyle(header).position;
        if (pos === 'sticky' || pos === 'fixed') top = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      }
      root.style.setProperty('--q-plp-top', `${top}px`);
      toolbar.classList.toggle('is-stuck', toolbar.getBoundingClientRect().top <= top + 1 && window.scrollY > 0);
    }
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(placeToolbar); } }, { passive: true });
    window.addEventListener('resize', placeToolbar);
    placeToolbar();

    // ---------- atrás / adelante ----------
    window.addEventListener('popstate', () => load(location.href, { push: false }));

    // categorías: centrar la activa
    $('.cat-pills .is-active', root)?.scrollIntoView({ inline: 'center', block: 'nearest' });

    afterRender();
  }

  const start = () => $$('[data-q-plp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (e) => init($('[data-q-plp]', e.target)));
})();
